import { LoaderSpinner } from '../../../../../../../../components/CiscoUi';
import styles from './index.module.css';

export type EmbeddAppLoaderProps = {
  embeddedAppStatus: EmbeddedAppStates;
};

export const EmbeddedAppLoader = ({
  embeddedAppStatus,
}: EmbeddAppLoaderProps) => {
  if (embeddedAppStatus !== 'LOADING') return <></>;

  return (
    <div className={styles.root}>
      <div className={styles.loader}>
        <LoaderSpinner />
      </div>
    </div>
  );
};
